var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div tag-filter"},[_c('ul',{staticClass:"tag-list"},_vm._l((_vm.tagTree),function(tag){return _c('tag-node',{key:tag.id,attrs:{"tag":tag,"mode":_vm.mode,"states":_vm.states},on:{"update":_vm.onUpdate}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }